// import moment from "moment";
import { getInitials } from '@/utility/CommonFunctions';
import moment from 'moment';
import { useRef } from 'react';
import { IEmployeeBirthday } from './UserDashboard';
import { RoutesLink } from '@/utility/RouteLinks';
import { useNavigate } from 'react-router-dom';

interface IDashboardEventCardProps {
  title: string;
  workList?: IEmployeeBirthday[];
  birthdayList?: IEmployeeBirthday[];
}

export default function DashboardEventCard({
  title,
  workList,
  birthdayList,
}: IDashboardEventCardProps) {
  const navigate = useNavigate();
  const currentDate = new Date();
  const listRef = useRef(null);

  const isToday = (dateString: string) => {
    const date = new Date(dateString);
    return (
      date.getDate() === currentDate.getDate() &&
      date.getMonth() === currentDate.getMonth()
    );
  };
  const isUpcoming = (dateString: string) => {
    const date = new Date(dateString);
    return (
      date.getDate() > currentDate.getDate() ||
      date.getMonth() > currentDate.getMonth() ||
      date.getFullYear() > currentDate.getFullYear()
    );
  };
  const isPending = title.includes('Pending');
  const listKey = title === 'Work Anniversary' ? 'joiningDate' : 'dob';
  const list = title === 'Work Anniversary' ? workList : birthdayList;
  const todayItems = list?.filter((item) => isToday(item[listKey] ?? '')) || [];
  const upcomingItems =
    list?.filter((item) => isUpcoming(item[listKey] ?? '')) || [];
  return (
    <div className="col-lg-6">
      <div className="card dash-card2">
        <div className="card-body">
          <div className="card-head d-flex justify-content-between align-items-center">
            <h3 className="card-title">
              {title === 'Birthday'
                ? title + ' 🎂'
                : isPending
                  ? title + ' ⏳'
                  : title + ' 🏢'}
            </h3>
            {!isPending && (
              <span className="text-primary fs-5 fw-bold">Today</span>
            )}
          </div>

          <ul className="list-unstyled card-scrollable" ref={listRef}>
            {/* {isPending ? (
              genericList && genericList.length > 0 ? (
                genericList.map((item) => (
                  <li key={item.id}>
                    <div className="d-flex justify-content-between align-items-center mt-2">
                      <div
                        className="user d-flex gap-3 mb-2"
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                          const link = title.includes('Leave')
                            ? `${RoutesLink?.leaveTeamDetail}/${item?.id}`
                            : title.includes('WFH')
                              ? `${RoutesLink?.wfhTeamRequestDetail}/${item?.id}`
                              : `${RoutesLink?.arTeamRequestDetail}/${item?.id}`;
                          navigate(link);
                        }}
                      >
                        {item?.image ? (
                          <img
                            src={item?.image}
                            alt="User"
                            loading="lazy"
                            className="user-avatar"
                            style={{
                              width: '30px',
                              height: '30px',
                              borderRadius: '50%',
                              objectFit: 'contain',
                            }}
                          />
                        ) : (
                          <span className="user-icon">
                            {getInitials(item.name)}
                          </span>
                        )}
                        <h4 className="title">{item.name}</h4>
                      </div>
                      <span className="fs-6">
                        {moment(item?.startDate).format('DD-MM')} -{' '}
                        {moment(item?.endDate).format('DD-MM')}
                      </span>
                    </div>
                  </li>
                ))
              ) : (
                <li className="col-12">
                  <span>No {title.toLowerCase()} requests.</span>
                </li>
              )
            ) : (
              <> */}
            {todayItems.length > 0 ? (
              todayItems.map((item) => (
                <li key={item.id}>
                  <div className="d-flex justify-content-between align-items-center mt-2">
                    <div
                      className="user d-flex gap-3 mb-2"
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        navigate(RoutesLink?.detailEmployee + `/${item?.id}`);
                      }}
                    >
                      {item?.profilePhoto ? (
                        <img
                          src={item?.profilePhoto}
                          alt="User"
                          loading="lazy"
                          className="user-avatar"
                          style={{
                            width: '30px',
                            height: '30px',
                            borderRadius: '50%',
                            objectFit: 'contain',
                          }}
                        />
                      ) : (
                        <span className="user-icon">
                          {getInitials(item.name)}
                        </span>
                      )}
                      <h4 className="title">{item.name}</h4>
                    </div>
                    <span className="fs-5">
                      {moment(item[listKey]).format('DD-MM')} -{' '}
                      {new Date().getFullYear()}
                    </span>
                  </div>
                </li>
              ))
            ) : (
              <li className="col-12">
                <span>
                  {title === 'Work Anniversary'
                    ? 'No work anniversaries today.'
                    : 'No birthdays today.'}
                </span>
              </li>
            )}

            <hr />
            <span className="text-black fw-medium fs-5">Upcoming</span>
            {upcomingItems.length > 0 ? (
              upcomingItems?.map((item) => (
                <li key={item.id}>
                  <div className="d-flex justify-content-between align-items-center mt-2">
                    <div
                      className="user d-flex gap-3 mb-2"
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        navigate(RoutesLink?.detailEmployee + `/${item?.id}`);
                      }}
                    >
                      {item?.profilePhoto ? (
                        <img
                          src={item?.profilePhoto}
                          alt="User"
                          loading="lazy"
                          className="user-avatar"
                          style={{
                            width: '30px',
                            height: '30px',
                            borderRadius: '50%',
                            objectFit: 'contain',
                          }}
                        />
                      ) : (
                        <span className="user-icon">
                          {getInitials(item.name)}
                        </span>
                      )}
                      <h4 className="title">{item.name}</h4>
                    </div>
                    <span className="fs-5">
                      {moment(item[listKey]).format('DD-MM')}-
                      {new Date().getFullYear()}
                    </span>
                  </div>
                </li>
              ))
            ) : (
              <li className="col-12">
                <span>
                  {title === 'Work Anniversary'
                    ? 'No upcoming work anniversaries.'
                    : 'No upcoming birthdays.'}
                </span>
              </li>
            )}
            {/* </> */}
            {/* )} */}
          </ul>
        </div>
      </div>
    </div>
  );
}
